import { AuthService } from '@services/auth.service'
import { AuthHandoffService } from '@services/auth-handoff.service'
import { Component, OnInit } from '@angular/core'
import { PATHS } from '@app/routes'
import { Router } from '@angular/router'

@Component({
    selector: 'app-signup-token-bridge',
    templateUrl: './signup-token-bridge.component.html',
})
export class SignupTokenBridgeComponent implements OnInit {
    error: string | null = null

    constructor(
        private authService: AuthService,
        private authHandoffService: AuthHandoffService,
        private router: Router
    ) { }

    ngOnInit() {
        const tokens = this.authHandoffService.consume()
        if (tokens === null || tokens.refreshToken === null) {
            this.error = 'We could not sign you in automatically. Please sign in with the password you created.'
            return
        }
        this.authService.saveSignupTokens(tokens.accessToken, tokens.refreshToken)
        this.router.navigate([PATHS.diary])
    }
}
